import { inject, ProviderToken } from '@angular/core';

export function injectRequired<T>(token: ProviderToken<T>): T {
    const value = inject(token, {optional: true});
    if (value == null) {
        const message = `[DI] Required token '${String(token)}' resolved to null. Check provider configuration.`;
        console.error(message);
        throw new Error(message);
    }
    return value;
}
